<template>
  <div>
    <!--顶部导航-->
    <template v-if="navigatorInfo">
      <div class="web_nav">
        
        <div class="web_nav_middle">
          <div class="left_logo" @click="toMain">
            <img src="../../../assets/img/jjhlogo.png">
          </div>
          <div class="middle_nav">
            <ul>
             <template v-for="(item,index) in navigatorInfo.programs">
               <li :class="currentTap == item.routeValue ? 'active':''" :key="index" @click="headerClick(item.routeValue)">{{item.title}}</li>
             </template>
            </ul>
          </div>
          <!-- <div class="right_search">
            <input placeholder="请搜索">
            <i class="iconfont icon-web-sousuo"></i>
          </div> -->
        </div>
        <!--移动端导航按钮-->
        <div class="mobile_nav_middle">
          <div class="left_logo">
            <img src="../../../assets/img/jjhlogo.png">
          </div>
          <i class="iconfont icon-web-caidan" @click.stop="ShowHidden = !ShowHidden"></i>
          <!--<i class="iconfont icon-web-guanbi"></i>-->
        </div>
      </div>
      <!--移动端导航菜单-->
      <div class="mobile_nav_content" v-if="ShowHidden">
        <div class="mobile_nav_list">
          <div @click="toMain">首页</div>
          <template v-for="(itemM,indexM) in navigatorInfo.programs">
            <div :key="indexM" @click="headerClick(itemM.routeValue)">{{itemM.title}}</div>
          </template>
        </div>
        <div class="mobile_mask" @click="ShowHidden = !ShowHidden" @touchmove.prevent></div>
      </div>
    </template>
      
    <!--<button @click="changLang">ccccc</button>-->
  
  </div>
  
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import store from '../../../store'
export default {
  name: 'navgate',
  components:{},
  props: {
    
  },

  data () {
    return {
      
      ShowHidden: false
    }
  },
  computed: {
   
    ...mapState("global", ["navigatorInfo","currentTap"]),

    

  },
  methods:{
    ...mapActions("global", ["ActionSetCurrentTap"]),
    headerClick(pageName){
      this.ActionSetCurrentTap(pageName);
      this.$router.push(pageName);
    },
    toMain(){
      this.ActionSetCurrentTap('');
      this.$router.push({name:'main'})
    },
    
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    },
    HiddenClick () {
      this.ShowHidden = false
    },
    
  },
  watch:{
    ShowHidden(val){
      if(val == true){
        
      }else{

      }
    }
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../../assets/css/ks_foundation.less';
    @import '../../../assets/css/ks_media.less';
    @import '../../../assets/fonts/iconfont.css';
    
</style>
